function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
export var LagrofyIso = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "#719837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1814 2.85547H2.81152V4.84694H27.1814V2.85547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1814 7.32031H2.81152V9.31179H27.1814V7.32031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1814 16.2266H2.81152V18.218H27.1814V16.2266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8726 20.6836H2.81152V22.6751H12.8726V20.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.189 20.6836H17.1279V22.6751H27.189V20.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8726 11.7734H2.81152V13.7649H12.8726V11.7734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.189 11.7734H17.1279V13.7649H27.189V11.7734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8726 25.1406H2.81152V27.1321H12.8726V25.1406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.189 25.1406H17.1279V27.1321H27.189V25.1406Z",
    fill: "white"
  }));
});